import React from "react";

export const Heading2 = ({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) => (
  <h2 className={`font-bold text-black text-xl mb-2 ${className || ""}`}>
    {children}
  </h2>
);
